






































































































































import { Job } from '@/@types/LibraryComponent';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import OrganizationIconTooltip from '@/components/common/OrganizationIconTooltip.vue';
import OrganizationNameTooltip from '@/components/common/OrganizationNameTooltip.vue';

@Component({
  components: {
    OrganizationIconTooltip,
    OrganizationNameTooltip,
  },
})
export default class JobCard extends Vue {
  @Prop()
  private job!: Job;

  private get price(): string {
    return (this.job.price * 10000).toLocaleString();
  }

  private get summary(): string {
    const summary = this.job.description.substring(0, 100);
    return (summary.length >= 100) ? summary + '...' : summary;
  }

  private companyname: string =
    '株式会社ヒプスター';

  private companydetail: string =
    '株式会社ヒプスター \n東京都渋谷区道玄坂1-16−15\n道玄坂NKビル2F\n代表取締役 大石賢司';

  @Emit('bookmark')
  private bookmark(): string {
    return this.job.id;
  }
  @Emit('open')
  private onClick(id: string): string {
    return id;
  }
}
